<template>
  <div class="protocal-link">
    <a class="link link-left" href="javascript:;" @click="openServiceLink">{{
      letter.fwtk
    }}</a>
    <span class="line">|</span>
    <a class="link link-right" href="javascript:;" @click="openPrivacyLink">{{
      letter.yszc
    }}</a>
  </div>
</template>

<script>
import serviceLink from '@mixins/officialTopupNew/serviceLink';
export default {
  name: 'ProtocolLink',
  mixins: [serviceLink],
  computed: {
    letter() {
      return this.$store.state.letter;
    }
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialTopupNew/_mixins.scss';

.protocal-link {
  @include dualLinkRowItems;
}
</style>
